<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="sTitle" placeholder="请输入介绍节点标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- 新增介绍节点 -->
    <el-dialog
      title="新增介绍节点"
      :visible.sync="addNewNoticeVisible"
      :before-close="cancel"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="ruleForm" label-width="80px">
          <el-form-item label="介绍节点标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="介绍节点内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addSchoolNews()">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑-->
    <el-dialog :close-on-click-modal="false" title="编辑介绍节点" :visible.sync="editNoticeVisible" :append-to-body="true" :before-close="cancel" width="50%">
      <div>
        <el-form ref="ruleForm" label-width="80px">
          <el-form-item label="介绍节点标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="页面显示顺序">
            <el-input v-model="orderNumber"></el-input>
          </el-form-item>
          <el-form-item label="介绍节点内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addSchoolNews()">确 定</el-button>
      </span>
    </el-dialog>

    <el-table
      ref="multipleeeeTable"
      :data="list"
      tooltip-effect="dark"
      empty-text=" "
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="Title" label="标题" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="DateCreated" label="创建时间"></el-table-column>
      <el-table-column prop="CreateDisplayName" label="创建人"></el-table-column>
      <el-table-column prop="AuthenticationTitle" label="申请标准"></el-table-column>
      <el-table-column prop="OrderNumber" label="排序" width="80"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            class="el-icon-edit"
            @click="edit(scope.row)"
            type="primary"
            title="编辑"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            class="el-icon-delete"
            @click="deleteMajor(scope.row.Id)"
            titlt="删除"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
      <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="onPageChangeHandler"
      :current-page="pageIndex"
      :page-sizes="[5, 15, 25, 30]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-show="total>0"
    ></el-pagination>
    </div>
  </div>
</template>

<script>
import NewThumbnail from "../../component/AliyunOSS/NewThumbnail.vue";
import { StringDecoder } from 'string_decoder';
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 5,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      introduceNodeId: "",
      orderNumber: 0,
      /* --------------------------------------- */
      id: "",
      introduceNodeIds: [],
      noDataShow: false,
      loadingShow: false,
      //介绍节点栏目
      columnList: [],
      school: null,
      hnSchoolId: "hnzjc",
      value: ""
    };
  },
  props: {
    type: {
      type: String
    },
    certifiId:{
      type: String,
      default:""
    }
  },
  components: {
    NewThumbnail
  },
  created() {
    this.getSchoolNewsList();
    // this.getNewsColumnList();
  },
  methods: {
    getSchoolNewsList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getAllAuthenticationNodeList", {
          authenticationId: this.certifiId,
          title: this.sTitle,
          type: this.type,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          }
        });
    },
    //获取介绍节点栏目列表
    getNewsColumnList: function() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getAuthenticationList", {
          type: this.type
        })
        .then(rst => {
          if (rst.code == 1) {
            that.columnList = rst.list;
          }
        });
    },
    onPageChangeHandler(page) {
      this.getSchoolNewsList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSchoolNewsList(1);
    },
    handleSelectionChange(val) {
      this.introduceNodeIds = [];
      val.forEach(element => {
        this.introduceNodeIds.push(element.Id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
        (this.editNoticeVisible = false),
        (this.title = ""),
        (this.content = ""),
        (this.introduceNodeIds = []);
      this.introduceNodeId = "";
      this.nodeId = "";
    },
    addSchoolNews() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/addAuthenticationNode", {
          nodeId: this.nodeId,
          cover: this.cover,
          content: this.content,
          title: this.title,
          authenticationId: this.certifiId,
          authenticationTitle: this.authenticationTitle,
          orderNumber: this.orderNumber,
          type: this.type
        })
        .then(rst => {
          if (rst.code == 1) {
            this.cancel();
            this.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            this.introduceNodeId = "";
            this.getSchoolNewsList();
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.title = row.Title;
      this.content = row.Content;
      this.nodeId = row.Id;
      this.orderNumber = row.OrderNumber;
    },
    deleteMajor(id) {
      this.introduceNodeIds.push(id);
      this.$confirm("此操作将删除该介绍节点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getSchoolNewsList(1);
    },
    deleteAll() {
      if (this.introduceNodeIds.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择介绍节点",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选介绍节点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteFun() {
      var that = this;
      this.$http
        .post("/api/XOrg/Authentication/deleteAuthenticationNode", {
          Ids: this.introduceNodeIds
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.getSchoolNewsList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>
